import { render } from "./UserCustomers.vue?vue&type=template&id=2de947de&scoped=true"
import script from "./UserCustomers.vue?vue&type=script&lang=js"
export * from "./UserCustomers.vue?vue&type=script&lang=js"

import "./UserCustomers.vue?vue&type=style&index=0&id=2de947de&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de947de"]])

export default __exports__